export const environment = {
  production: false,
  SERVER_URL: "https://api.xcelapp.com/cmp/v2", // old live
  BASE_URL: "https://api.xcelapp.com", // NEW live
  // BASE_URL: "https://sandbox-api.xcelapp.com", // sandbox
  MIXPANEL_TOKEN: "f18f4381c47bb4942afbfac90c0a65b7", // sandbox
};
